import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['hiddenInput', 'placeholderText', 'valueText', 'selectedOption']

  connect () {
    this.hiddenInputTarget.setAttribute('data-all-fields-required-to-enable-element-target', 'field')
    this.hiddenInputTarget.setAttribute(
      'data-action',
      'input->all-fields-required-to-enable-element#setEnabled'
    )

    this.updateSelectedOptions()

    if (this.hiddenInputTarget.value.length > 0 && this.hasPlaceholderTextTarget && this.hasValueTextTarget) {
      this.placeholderTextTarget.classList.add('hidden')
      this.valueTextTarget.classList.remove('hidden')
    }
  }

  updateSelectedOptions () {
    const value = this.hiddenInputTarget.value

    this.selectedOptionTargets.forEach((target) => {
      const shouldShow = target.dataset.visibleIfValue === value
      target.classList.toggle('hidden', !shouldShow)
    })
  }

  updateSelection (event) {
    const element = event.currentTarget
    const value = element.getAttribute('data-dropdown-select-value')

    if (value.length > 0) {
      this.hiddenInputTarget.value = value

      if (this.hasValueTextTarget) {
        const text = element.textContent.trim()
        this.valueTextTarget.textContent = text.trim()
        this.valueTextTarget.classList.remove('hidden')
      }

      if (this.hasPlaceholderTextTarget) {
        this.placeholderTextTarget.classList.add('hidden')
      }
    } else {
      this.hiddenInputTarget.value = null

      if (this.hasValueTextTarget) {
        this.valueTextTarget.textContent = null
        this.valueTextTarget.classList.add('hidden')
      }

      if (this.hasPlaceholderTextTarget) {
        this.placeholderTextTarget.classList.remove('hidden')
      }
    }

    this.updateSelectedOptions()
    this.hiddenInputTarget.dispatchEvent(new Event('input', { bubbles: true }))
  }
}
